import LocalizedStrings from 'localized-strings';

export const locales = new LocalizedStrings({
  en: {
    callout:
      'Estimated amount based on your incoming payments (excluding payments marked as "personal" in the Shine application).',
    complementaryRevenue: 'Including {amount} in supplementary income',
    complementaryRevenueWithVAT:
      'Of which {complementaryRevenue} is supplementary income and {vatAmount} deducted VAT',
    error: 'An error occurred. Please try again.',
    form: {
      distributionAmounts:
        'The total mixed income must be equal to the total turnover excl. tax',
      label: {
        bic: 'Amount for commercial or craft services (BIC)',
        bicWithVAT: 'Amount excl. VAT for commercial or craft services (BIC)',
        bnc: 'Amount for other services and self-employed activities (BNC)',
        bncWithVat:
          'Amount excl. VAT for other services and self-employed activities (BNC)',
        complementaryRevenue:
          'Turnover collected excluding Shine account (if applicable)',
        revenue: 'Turnover collected on your Shine account',
        selling: 'Amount for sales of goods, catering and accommodation (BIC)',
        sellingWithVAT:
          'Amount excl. VAT for sales of goods, catering and accommodation (BIC)',
        vat: 'Total amount of VAT collected over the period',
        vatInfo: 'Learn more about my VAT calculation',
      },
    },
    mixActivity: 'Mixed activity',
    more: 'Learn more',
    revenue: 'Your turnover',
    subtitle:
      'Fill in this information to estimate your social security contributions as accurately as possible.',
    title: 'Your situation',
    withoutVat: 'excl. VAT',
  },
  fr: {
    callout:
      'Montant estimé sur la base de vos paiements entrants (à l’exception des paiements marqués comme “personnels” dans l’application Shine).',
    complementaryRevenue: 'Dont {amount} de complément de revenu',
    complementaryRevenueWithVAT:
      'Dont {complementaryRevenue} de complément de revenu et {vatAmount} de TVA déduite.',
    error: 'Une erreur est survenue. Veuillez réessayer.',
    form: {
      distributionAmounts:
        "Le total des revenus mixtes doit être égal au chiffre d'affaires total",
      label: {
        bic: 'Prestations de services commerciales ou artisanales (BIC)',
        bicWithVAT:
          'Montant HT des prestations de services commerciales ou artisanales (BIC)',
        bnc: 'Autres prestations de service et activités libérales (BNC)',
        bncWithVat:
          'Montant HT des autres prestations de service et activités libérales (BNC)',
        complementaryRevenue:
          'Chiffre d’affaires TTC encaissé hors compte Shine (si applicable)',
        revenue: 'Chiffre d’affaires TTC encaissé sur votre compte Shine',
        selling: 'Vente de biens, restauration, hébergement (BIC)',
        sellingWithVAT:
          'Montant HT de vente de biens, restauration, hébergement (BIC)',
        vat: 'Montant total de TVA encaissé sur la période',
        vatInfo: 'En savoir plus sur le calcul de ma TVA.',
      },
    },
    mixActivity: 'Activité mixte',
    more: 'En savoir plus',
    revenue: 'Votre chiffre d’affaires',
    subtitle:
      'Remplissez ces informations pour estimer au plus juste vos cotisations sociales.',
    title: 'Votre situation',
    withoutVat: 'HT',
  },
} as const);
